/* This example requires Tailwind CSS v2.0+ */
import { Dialog } from '@headlessui/react'
import { XCircleIcon, XMarkIcon } from '@heroicons/react/20/solid'

export default function ErrorAlert(props) {
  return (
    <div className="z-10">
    <div className="rounded-md bg-[#F5EDEB] p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-red-400" aria-hidden="true" />
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-red-800">{props.message}</p>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              type="button"
              className="inline-flex rounded-md bg-[#F5EDEB] p-1.5 text-red-500 hover:bg-[#EDE3E0] focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
              onClick={() => props.setShowErrorAlert(false)}
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
    </div>
  )
}
